import React from 'react';
import { Box, Link, Text, Icon, BoxProps, useClipboard } from '@chakra-ui/core';

interface Props {
	title?: string;
	rest: BoxProps;
}

export const SocialLinks = ({ title, ...rest }: Props) => {
	const isBrowser = typeof window !== `undefined`;

	return isBrowser ? (
		<Box {...rest}>
			<Text d="inline" mr={3}>
				Share:
			</Text>
			<Link
				href={
					'http://www.facebook.com/sharer.php?u=' +
					window.location.href +
					'&t=' +
					(title || '')
				}
			>
				<Icon name="facebook" size="24px" mr={2} />
			</Link>
			<Icon name="shareLink" size="24px" mr={2} />
		</Box>
	) : null;
};
